export enum EnumRoles {
  MANAGER = 'Manager',
  MECHANIC_HYDRAULIC = 'Mechanic Hydraulic',
  MECHANIC_BUCKET = 'Mechanic Bucket',
}
